/**
 * Migration Helper
 * Backfills lastLoginAt for users who don't have it set
 * Uses updatedAt as a fallback estimate
 */

import { collection, getDocs, doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';

const USERS_COLLECTION = 'users';

/**
 * Backfill lastLoginAt for users missing it
 * Uses updatedAt as estimate if available
 * @returns {Promise<Object>} Migration results
 */
export async function backfillLastLogin() {
  try {
    console.log('­ƒöä Starting lastLoginAt migration...');
    
    const usersRef = collection(db, 'users');
    const querySnapshot = await getDocs(usersRef);
    
    let updated = 0;
    let skipped = 0;
    const results = [];
    const updatePromises = [];
    
    // Process all users
    for (const docSnapshot of querySnapshot.docs) {
      const data = docSnapshot.data();
      const userId = docSnapshot.id;
      
      // Skip if lastLoginAt already exists
      if (data.lastLoginAt) {
        skipped++;
        continue;
      }
      
      // Use updatedAt as fallback, or createdAt, or current time
      let estimatedLastLogin = null;
      if (data.updatedAt) {
        estimatedLastLogin = data.updatedAt;
      } else if (data.createdAt) {
        estimatedLastLogin = data.createdAt;
      } else {
        estimatedLastLogin = serverTimestamp();
      }
      
      // Create update promise
      const updatePromise = updateDoc(doc(db, USERS_COLLECTION, userId), {
        lastLoginAt: estimatedLastLogin,
        updatedAt: serverTimestamp(),
      })
      .then(() => {
        updated++;
        results.push({
          uid: userId,
          email: data.email,
          status: 'updated',
          used: data.updatedAt ? 'updatedAt' : (data.createdAt ? 'createdAt' : 'current time')
        });
        console.log(`Ô£à Updated lastLoginAt for ${data.email} (${userId})`);
      })
      .catch((error) => {
        console.error(`ÔØî Failed to update ${data.email}:`, error);
        results.push({
          uid: userId,
          email: data.email,
          status: 'error',
          error: error.message
        });
      });
      
      updatePromises.push(updatePromise);
    }
    
    // Wait for all updates to complete
    await Promise.all(updatePromises);
    
    console.log(`Ô£à Migration complete: ${updated} updated, ${skipped} skipped`);
    
    return {
      updated,
      skipped,
      total: querySnapshot.size,
      results
    };
  } catch (error) {
    console.error('ÔØî Migration failed:', error);
    throw error;
  }
}

